const themePageViewProps = theme =>
  theme
    ? {
        themeName: theme.title,
        themeId: theme.id,
        ingredientName: theme.ingredients.map(ingredient => ingredient.title),
        ingredientId: theme.ingredients.map(ingredient => ingredient.id),
      }
    : null;

export default themePageViewProps;
